import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import Products from "@/views/Products.vue";
import Devices from "@/views/products/Devices.vue";
import Solutions from "@/views/products/Solutions.vue";
import SolutionsGateway from "@/views/products/details/Gateway.vue";
import SolutionsHumidity from "@/views/products/details/Humidity.vue";
import SolutionsIrremote from "@/views/products/details/Irremote.vue";
import SolutionsAlarm from "@/views/products/details/Alarm.vue";
import SolutionsDimmer from "@/views/products/details/Dimmer.vue";

import News from "@/views/news/NewsList.vue";
import NewsCompany from "@/views/news/Company.vue";
import NewsIndustry from "@/views/news/Industry.vue";

import ServiceSupport from "@/views/service/Support.vue";
import ServiceFaq from "@/views/service/Faq.vue";
import ServiceDownload from "@/views/service/Downloads.vue";

import AboutCompany from "@/views/about/Company.vue";
import AboutTeam from "@/views/about/Team.vue";
import ContactPage from "@/views/ContactPage.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { path: "/", name: "Home", component: Home },
    { path: "/products", name: "Products", component: Products },
    { path: "/products/Devices", name: "Devices", component: Devices },
    { path: "/products/Solutions", name: "Solutions", component: Solutions },

    {
      path: "/products/Solutions/details/gateway",
      name: "SolutionsGateway",
      component: SolutionsGateway,
    },
    {
      path: "/products/Solutions/details/humidity",
      name: "SolutionsHumidity",
      component: SolutionsHumidity,
    },
    {
      path: "/products/Solutions/details/irremote",
      name: "SolutionsIrremote",
      component: SolutionsIrremote,
    },
    {
      path: "/products/Solutions/details/alarm",
      name: "SolutionsAlarm",
      component: SolutionsAlarm,
    },
    {
      path: "/products/Solutions/details/dimmer",
      name: "SolutionsDimmer",
      component: SolutionsDimmer,
    },

    { path: "/news", name: "News", component: News },
    { path: "/news/company", name: "NewsCompany", component: NewsCompany },
    { path: "/news/industry", name: "NewsIndustry", component: NewsIndustry },

    {
      path: "/service/support",
      name: "ServiceSupport",
      component: ServiceSupport,
    },
    { path: "/service/faq", name: "ServiceFaq", component: ServiceFaq },
     { path: "/service/downloads", name: "ServiceDownload", component: ServiceDownload },

    { path: "/about/company", name: "AboutCompany", component: AboutCompany },
    { path: "/about/team", name: "AboutTeam", component: AboutTeam },

    { path: "/contact", name: "Contact", component: ContactPage },
  ],
});
